import React, { createContext, useState, useContext } from 'react';
import NotificationSnackbar from '../notificationSnackbar';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  const showNotification = (message, severity = 'info', duration = 2000) => {
    setNotification({ open: true, message, severity, duration });
  };

  // Close handler
  const handleClose = () => setNotification(prev => ({ ...prev, open: false }));

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationSnackbar
        open={notification.open}
        onClose={handleClose}
        message={notification.message}
        severity={notification.severity}
        duration={notification.duration}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
